var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-window',{model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('menu-window'),_c('reset-password-window'),_c('edit-profile'),_c('edit-student-profile')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }